import { compose, withHandlers } from "recompose";
import { riskmedicalPerMemberUtils } from "reducers/utils";

export const withActionHandlers = compose(
  withHandlers({
    onPerMemberClick: ({ benefit, onChangePerMemberSelection }) => (plan, member) => event => {
      const {
        eligibleMembers: { members },
        options,
        ...restPlan
      } = plan;

      const maxEnroledMembers = parseInt(
        members && members.length
          ? members[0].maxEnroledMembers
          : members
            ? members.maxEnroledMembers
            : 0
      );
      const { key } = member;

      const selectedMembers = members.map(member => {
        if (member.key === key) {
          member.isSelected = event.target.checked;
        }
        return member;
      });

      // fitler selected members
      const filterSelectedMembers = selectedMembers
        .map(member => ({
          ...member,
          // make sure that employee is selected if the plan contain Employee
          isSelected: member.type === "Employee" ? true : member.isSelected,
        }))
        .filter(member => member.isSelected);

      const selected = selectedMembers.filter(
        member => member.isSelected && member.type !== "Employee"
      ).length;

      if (maxEnroledMembers >= 1) {
        selectedMembers.forEach(member => {
          if (selected >= maxEnroledMembers) {
            if (member.type !== "Employee" && member.isSelected && member.selectable) {
              member.isLimit = "false";
            } else if (member.type !== "Employee" && member.selectable) {
              member.isLimit = "true";
            }
          } else {
            member.isLimit = "false";
          }
        });
      }

      let selectedPlanOptions = null;
      // reset plan option selection
      if (options) {
        selectedPlanOptions = options.map(option => {
          option.isSelected = false;

          return option;
        });

        // filter selected member types
        const filterMemberTypes = riskmedicalPerMemberUtils.filterMemberTypeSelected(
          filterSelectedMembers
        );

        const isSpouse =
          filterSelectedMembers.length > 0
            ? riskmedicalPerMemberUtils.containEmployeeSpouse(filterMemberTypes)
            : false;
        const isChildren =
          filterSelectedMembers.length > 0
            ? riskmedicalPerMemberUtils.containEmployeeChildren(filterMemberTypes)
            : false;
        const isCO =
          filterSelectedMembers.length > 0
            ? riskmedicalPerMemberUtils.isChildrenOnly(filterMemberTypes)
            : false;
        const isSO =
          filterSelectedMembers.length > 0
            ? riskmedicalPerMemberUtils.isSpouseOnly(filterMemberTypes)
            : false;
        const isDO =
          filterSelectedMembers.length > 0
            ? riskmedicalPerMemberUtils.isDependentOnly(filterMemberTypes)
            : false;
        const isFamily = isDO ? false : riskmedicalPerMemberUtils.containFamily(filterMemberTypes);

        let memberType = "EE";

        if (isFamily) {
          memberType = "EF";
        } else if (isSpouse) {
          memberType = "ES";
        } else if (isChildren) {
          memberType = "EC";
        } else if (isCO) {
          memberType = "CO";
        } else if (isSO) {
          memberType = "SO";
        } else if (isDO) {
          memberType = "DO";
        }

        selectedPlanOptions = options.map(option => {
          if (option.type === memberType) {
            option.isSelected = true;
          }
          return option;
        });
      }

      let updatedPlan = {
        eligibleMembers: {
          members: selectedMembers,
        },
        options: selectedPlanOptions,
        ...restPlan,
      };

      onChangePerMemberSelection(benefit, updatedPlan);
    },
  })
);



// WEBPACK FOOTER //
// ./components/employee/shop/PlanPerMemberEventHandlers.js